import React from 'react';
import { CheckCircle2, ArrowRight, X, FileSpreadsheet, FileText, BookOpen, ClipboardList } from 'lucide-react';
import { Button } from '../ui/button';

const n = (c, one, many) => `${c} ${c === 1 ? one : many}`;

/** Plain-English recap shown right after "Build the response", with one button to the next step. */
export const BuildRecap = ({ recap, project, onNext, onClose }) => {
  const r = recap || {};
  const parts = [];
  if (r.sheets) parts.push({ Icon: FileSpreadsheet, text: `${n(r.sheets, 'question sheet', 'question sheets')} (${n(r.rows || 0, 'row', 'rows')})` });
  if (r.narratives) parts.push({ Icon: FileText, text: `${n(r.narratives, 'narrative', 'narratives')} with ${n(r.sections || 0, 'section', 'sections')}` });
  if (r.reference_files) parts.push({ Icon: BookOpen, text: n(r.reference_files, 'reference file', 'reference files') });
  if (r.forms) parts.push({ Icon: ClipboardList, text: n(r.forms, 'form or attachment to return', 'forms or attachments to return') });
  const sentence = parts.map((p) => p.text).join(', ').replace(/, ([^,]*)$/, ' and $1');
  const nextTab = r.sheets ? 'annexures' : r.narratives ? 'narratives' : 'checklist';
  const nextLabel = r.sheets ? 'Shape the answers' : r.narratives ? 'Write the narratives' : 'Open the checklist';
  return (
    <div className="rounded-lg border border-emerald-300 bg-emerald-50 px-4 py-3 flex items-start gap-3" data-testid="rfp-build-recap">
      <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-emerald-900">Response built for {project.client_name || project.name}</p>
        <p className="text-xs text-emerald-900/90 mt-0.5" data-testid="rfp-build-recap-text">
          Blueprint set up <b>{sentence || 'the response'}</b>.{r.sheets ? ' Question sheets are being matched against the Capability Library now — suggested answers appear as each sheet finishes.' : ''}{r.commercial ? ' A commercials item was added to the checklist.' : ''}
        </p>
        <ul className="flex flex-wrap gap-x-4 gap-y-1 mt-1.5 text-[11px] text-emerald-800">
          {parts.map((p, i) => <li key={i} className="inline-flex items-center gap-1"><p.Icon className="w-3 h-3" />{p.text}</li>)}
        </ul>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <Button size="sm" className="h-8 text-xs bg-[#0F2040] hover:bg-[#1A3055] text-white" onClick={() => onNext(nextTab)} data-testid="rfp-build-recap-next">Next: {nextLabel}<ArrowRight className="w-3.5 h-3.5 ml-1" /></Button>
        <button type="button" className="text-emerald-700/60 hover:text-emerald-900 p-1" onClick={onClose} data-testid="rfp-build-recap-close"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
